export const highlightText = (
  text: string | undefined,
  searchWords: string[],
): string => {
  if (!text) return '';

  const pattern = new RegExp(`(${searchWords.join('|')})`, 'gi');
  return text.replace(pattern, '<span class="highlightText">$1</span>');
};
